var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSewagePump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.2 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Sewage Ejector Pump") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 42.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.6,
    y: 42.5,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.6,42.5 29.6,45.5 33.4,45.5 32.6,42.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.8,45.5 20.6,45.5 20.6,42.5 17.6,42.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,8.6h11.7V3.8H19.2V8.6z M20,4.6h10.1v3.2H20V4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,31h-9.6c-0.9,0-1.7,0.8-1.7,1.7v1.4h-2.1c-0.5,0-1-0.1-1.1-1.1V14.5c0-2.1-1.1-3.2-3.2-3.2h-5.1V10h-2V0.9 c0-0.2-0.1-0.5-0.3-0.6C34.4,0.1,34.1,0,33.9,0H16.3c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6v17.8h-0.8 c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6v1.1h-3.5v-3.5H8.3v-0.4v-1v-0.6v-1v-1.6H2.4v1.6v1V16v1v0.4H0.1V18 c0,2.3,0,4.8,0.1,7.5c0.1,2.3,1.2,3.8,3.3,4.2c0.4,0.1,1,0.1,1.8,0.1c0.2,0,0.5,0,0.8,0h7.5v1.3l-4.3,7v9.1c0,0.2,0.1,0.5,0.3,0.6 c0.2,0.2,0.4,0.3,0.6,0.3h29.9c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2l-5-7V19.6c0-0.2-0.1-0.5-0.3-0.6 c-0.2-0.2-0.4-0.3-0.6-0.3h-0.4v-2.9h2v-1.1l4.4,0c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.5v18c0,1.4,0.3,2.5,1,3.2 c0.7,0.7,1.8,1.1,3.2,1.1h2.3v9c0,0.9,0.8,1.7,1.7,1.7h9.6c0.9,0,1.7-0.8,1.7-1.7V32.7C61.2,31.8,60.5,31,59.5,31z M3.3,13.7h4v0.6 h-4V13.7z M3.3,15.3h4V16h-4V15.3z M3.3,16.9h4v0.4h-4V16.9z M13,28.4H6.1c-1.4,0-2,0-2.3-0.1c-1.4-0.3-2.1-1.2-2.1-2.8 c-0.1-2.4-0.1-4.7-0.1-6.7h7v3.5H13V28.4z M16.9,1.5h16.4v16.9H16.9V1.5z M14.9,46.7l1.5-6h17l1.9,6H14.9z M39.5,38.6v8.1h-3.3 l-2.2-6.8H15.8l-1.7,6.8h-3.3v-8.1l4.3-7V20.2h19.5v11.4L39.5,38.6z M35.7,14.7h-0.8v-3.5h0.8V14.7z M48.2,36.4h-2.3 c-1.1,0-1.9-0.3-2.4-0.8c-0.5-0.5-0.7-1.3-0.7-2.4v-18c0-0.6-0.2-1-0.5-1.3c-0.3-0.3-0.7-0.4-1.2-0.4h-4.4v-1.1h5.1 c1.5,0,2.1,0.6,2.1,2.1l0,18.5c0.3,1.9,1.5,2.2,2.2,2.2h2.1V36.4z M59.7,46.5c0,0.1-0.1,0.2-0.2,0.2h-9.6c-0.1,0-0.2-0.1-0.2-0.2 V32.7c0-0.1,0.1-0.2,0.2-0.2h9.6c0.1,0,0.2,0.1,0.2,0.2V46.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSewagePump);
export default __webpack_public_path__ + "static/media/sewage-pump.700ea3d4f01d097a036aa3c33c27b01a.svg";
export { ForwardRef as ReactComponent };